import { useEffect, useState } from "react";
import "../../styles/scss/about-us.module.scss";
import 'react-multi-carousel/lib/styles.css';

const AboutUsGallery = ({ imageSets }) => {
    const totalSets = imageSets.length;
    const intervalDurations = [4800, 5800, 6800, 7800, 8800];

    const [currentIndices, setCurrentIndices] = useState(Array(totalSets).fill(0));

    useEffect(() => {
        const intervals = currentIndices.map((_, setIndex) => {
            return setInterval(() => {
                setCurrentIndices((indices) =>
                    indices.map((index, i) =>
                        i === setIndex ? (index + 1) % imageSets[i].length : index
                    )
                );
            }, intervalDurations[setIndex % intervalDurations.length]);
        });

        return () => intervals.forEach(clearInterval);
    }, [imageSets]);

    return (
        <div className="about-us-gallery">
            <div className="about">
                <div className="first-card">
                    {imageSets.map((images, setIndex) =>
                        images.map((src, index) => (
                            <img
                                key={`${setIndex}-${index}`}
                                className={`gallery-img ${index === currentIndices[setIndex] ? 'active' : ''}`}
                                style={{
                                    opacity: index === currentIndices[setIndex] ? 1 : 0,
                                    transition: 'opacity 1s ease-in-out',
                                }}
                                src={src}
                                alt={`Image ${index + 1}`}
                                width={100}
                                height={100}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default AboutUsGallery;